import React, { useEffect, useState } from 'react';
import { Switch, Spin } from 'antd';
import { translate } from 'libs';
import { useAppDispatch } from 'app/hooks';
import { IPayloadGetSettingServey, IPayloadUpdateSettingServey } from 'pages/setting/interfaces';
import { getSettingServeyAction, updateSettingServeyAction } from 'actions/organization';
import { ModalConfirm } from 'components/modal-confirm';
import { has } from 'lodash';

const SettingServey = () => {
  const dispatch = useAppDispatch();
  const [org, setOrg] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalConfirm, setIsModalConfirm] = useState<boolean>(false);
  const [status, setStatus] = useState<boolean>(true);

  const onChange = (checked: boolean) => {
    setStatus(checked);
    setIsModalConfirm(!isModalConfirm);
  };

  const handleOnOff = () => {
    setLoading(true);
    setIsModalConfirm(!isModalConfirm);
    const payload: IPayloadUpdateSettingServey = {
      value: status,
      onSuccess: () => {
        setOrg({ ...org, is_allow_servey: status });
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      },
    };

    return dispatch(updateSettingServeyAction(payload));
  };

  useEffect(() => {
    const payload: IPayloadGetSettingServey = {
      onSuccess: (dataOrg) => {
        if (dataOrg) {
          let new_data_org = { ...dataOrg };
          if (!has(dataOrg, 'is_allow_servey')) {
            new_data_org['is_allow_servey'] = false;
          }
          setOrg(new_data_org);
          setStatus(new_data_org.is_allow_servey);
        }
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      },
    };
    return dispatch(getSettingServeyAction(payload));
  }, [dispatch]);

  if (loading)
    return (
      <div className="other-setting-loading">
        <Spin spinning={loading} size="small"></Spin>
      </div>
    );

  return (
    <>
      <div className="other-setting">
        <div className="wrap_header">
          <div className="left">
            <Switch
              checked={org?.is_allow_servey}
              onChange={onChange}
              style={org?.is_allow_servey ? { background: '#34C759' } : { background: '#FF3B30' }}
            />
          </div>
          <div className="right">
            <p className="title">{translate('setting.servey.title')}</p>
          </div>
        </div>
        <div className="wrap-text-des">
          <p style={org?.is_allow_servey ? { color: '#34C759' } : { color: '#FF3B30' }}>
            {translate(`${org?.is_allow_servey ? 'setting.servey.on' : 'setting.servey.off'}`)}
          </p>
          <p className="text-des">{translate('setting.servey.des')}</p>
        </div>
      </div>
      <ModalConfirm
        isDeleted={false}
        visible={isModalConfirm}
        handleOk={handleOnOff}
        handleCancel={() => {
          setIsModalConfirm(!isModalConfirm);
        }}
        title={translate(
          `${
            !status
              ? 'setting.servey.modal.title.on.to.off'
              : 'setting.servey.modal.title.off.to.on'
          }`
        )}
        contentText={translate(
          `${!status ? 'setting.servey.modal.des.on.to.off' : 'setting.servey.modal.des.off.to.on'}`
        )}
        textConfirmBtn={translate(
          `${
            !status
              ? 'setting.servey.modal.btn.on.to.off.ok'
              : 'setting.servey.modal.btn.off.to.on.ok'
          }`
        )}
        textCancelBtn={translate('setting.servey.modal.btn.cancel')}
      />
    </>
  );
};

export default React.memo(SettingServey);
